import { setCurrency, setNumberWithPoint } from 'utils/utils'
import moment from 'moment'
import { Link } from 'react-router-dom'

export const CARD_PRODUCT_COMPARISON = [
    {
        title: 'Total Product Sold',
        name: 'total_product_sold',
        isCurrency: false,
    },
    {
        title: 'Total Order',
        name: 'total_order',
        isCurrency: false,
    },
    {
        title: 'Total Product Price',
        name: 'total_product_price',
        isCurrency: true,
    },
]

export const TABLE_PRODUCT = {
    name: 'Product',
    column: [
        {
            name: 'Nama Produk',
            key: 'name',
            className: 'capitalize',
            render: ({ item }) => (
                <Link
                    to={
                        item?.is_gift
                            ? `/product/gift-list/update-gift?giftId=${item?.id}`
                            : `/product/product-list/update-product?productId=${item?.id}`
                    }
                    className={'font-medium text-blue-90 hover:font-bold hover:underline'}
                >
                    {item?.name}
                </Link>
            ),
        },
        {
            name: 'Kode SKU',
            key: 'sku',
            className: 'max-w-[300px] break-words',
        },
        {
            name: 'Brand',
            key: 'brand_name',
            className: 'capitalize',
        },
        {
            name: 'Produk Terjual',
            key: 'product_sold',
            render: ({ value }) => <div>{value ? setNumberWithPoint(value) : '-'}</div>,
        },
        {
            name: 'Total Order',
            key: 'total_order',
            render: ({ value }) => <div>{value ? setNumberWithPoint(value) : '-'}</div>,
        },
        {
            name: 'Total Product Price',
            key: 'total_product_price',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
    order_by: 'total_product_sold',
    order_type: 'desc',
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
}

export const SORT_PRODUCT = [
    {
        label: 'Sort By Product Sold Desc',
        key: 'total_product_sold-desc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Product Sold Asc',
        key: 'total_product_sold-asc',
        name: 'sort-product',
    },
]

export const INITIAL_ADVANCE_FILTER = {
    brand_ids: [],
}
